import adminAlertTemplateApi, { resolveAssetUrl } from './adminAlertTemplate.api';

const TEMPLATE_DEFAULTS = {
  layout: '{}',
  actions: '{}',
  buttonlayout: '[]',
  edittextdata: '[]',
  generatedlayout: '[]',
  dimensions: '{"width":720,"height":1000}',
  catlist: [],
  delay: '0',
  previewurl: '',
  imageurl: '',
  industrytypeid: -1,
  availableglobal: true,
  isemergency: false,
  description: '',
  type: 'alert',
  status: 'template',
};

function datafix(data) {
  const fixed = { ...data };
  Object.keys(TEMPLATE_DEFAULTS).forEach((key) => {
    if (fixed[key] === undefined || fixed[key] === null) {
      fixed[key] = TEMPLATE_DEFAULTS[key];
    }
  });
  if (fixed.previewurl) fixed.previewurl = resolveAssetUrl(fixed.previewurl);
  if (fixed.imageurl) fixed.imageurl = resolveAssetUrl(fixed.imageurl);
  if (fixed.applayout?.previewImage) {
    fixed.applayout = {
      ...fixed.applayout,
      previewImage: resolveAssetUrl(fixed.applayout.previewImage),
    };
  }
  return fixed;
}

function unwrap(res) {
  if (!res?.success) {
    throw new Error(res?.message || 'Request failed');
  }
  return res.data;
}

export const templateApi = {
  mode: 'api',

  async loadById(id) {
    const res = await adminAlertTemplateApi.getById(id);
    const t = unwrap(res);
    return t ? datafix(t) : null;
  },

  async save(template) {
    const payload = datafix({ ...template });
    let res;
    if (payload.id) {
      res = await adminAlertTemplateApi.update(payload.id, payload);
    } else {
      res = await adminAlertTemplateApi.create(payload);
    }
    return datafix(unwrap(res));
  },

  async deleteTemplate(id) {
    await adminAlertTemplateApi.delete(id);
  },

  async listAll(type) {
    const params = {};
    if (type) params.type = type;
    const res = await adminAlertTemplateApi.list(params);
    return unwrap(res).map(datafix);
  },

  async listByStatus(status, type = 'alert') {
    const res = await adminAlertTemplateApi.list({ status, type });
    return unwrap(res).map(datafix);
  },

  async listPickerOptions({ search, type, exclude, highlight, limit } = {}) {
    const params = { limit };
    if (search) params.q = search;
    if (type) params.type = type;
    if (exclude) params.exclude = exclude;
    if (highlight) params.highlight = highlight;
    const res = await adminAlertTemplateApi.listPickerOptions(params);
    return unwrap(res);
  },

  async createNew(name, status = 'template', type = 'alert') {
    const res = await adminAlertTemplateApi.create({
      name,
      status,
      type,
      layout: '{"objects":[],"background":"#FFFFFF"}',
      dimensions: '{"width":720,"height":1000}',
      applayout: {
        backgroundColor: '255,255,255,1',
        previewImage: '',
        buttonLayout: [],
        textLayout: [],
        imageLayout: [],
        editableLayout: [],
      },
    });
    return datafix(unwrap(res));
  },

  async clone(source, status = 'template', type = 'alert') {
    const res = await adminAlertTemplateApi.clone(source.id);
    const cloned = datafix(unwrap(res));
    if (status !== 'template' || type !== 'alert') {
      return templateApi.save({ ...cloned, status, type });
    }
    return cloned;
  },

  async publish(templateId) {
    const res = await adminAlertTemplateApi.publish(templateId);
    return datafix(unwrap(res));
  },

  createEmpty(type = 'alert', status = 'template') {
    return {
      ...TEMPLATE_DEFAULTS,
      name: 'Create',
      type,
      status,
      applayout: {
        backgroundColor: '255,255,255,1',
        previewImage: '',
        buttonLayout: [],
        textLayout: [],
        imageLayout: [],
        editableLayout: [],
      },
    };
  },
};

export default templateApi;
